import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./lang";
import moment from "moment";
import "lib-flexible/flexible";
import { Lazyload, Locale } from "vant";
import { Icon, Button, Col, Row, Toast, Dialog, Notify } from "vant";
import enUS from "vant/lib/locale/lang/en-US.js";
import jaJP from "vant/lib/locale/lang/ja-JP.js";
import { ProfileInfo } from "./model/system";
import * as _ from "lodash";
import pageFrame from "@/components/pageFrame.vue";
import bottonBar from "@/components/bottonBar.vue";
import headerBar from "@/components/headerBar.vue";
import { categoryMap } from "./model/Base";
import globalShare from "./utils/globalShare";
import dataShare from "./views/mall/dataShare";
import loadingFrame from "@/components/loadingFrame.vue";
import amap from "@/views/modules/aMap.vue";
import { isOfw } from "./utils/utils";

Vue.use(Lazyload);
Vue.mixin({
  computed: {
    profile(): ProfileInfo {
      // eslint-disable-next-line
      return (<any>this.$store).getters.profile;
    },
  },
});
window.addEventListener("popstate", function(e) {
  // eslint-disable-next-line
  //indexSurvey
  if (dataShare.indexSurvey) {
    dataShare.indexSurvey = false;
    return;
  }
  globalShare.isBack = true;
});
// document.body.addEventListener("touchmove", e => e.preventDefault(), { passive: false });
// document.body.addEventListener(
//   "touchmove",
//   function(e) {
//     if (e)
//       if (!hasParent(e.target, "#需要滑动的容器的class#")) {
//         e.preventDefault();
//       }
//   },
//   { passive: false }
// );

// function hasParent(element, parentClass) {
//   var ele = document.querySelector(element);
//   while (!ele.is("body")) {
//     if (ele.hasClass(parentClass)) {
//       return true;
//     }
//     ele = ele.parent();
//   }
//   return false;
// }
if (localStorage.lange == "en") {
  Locale.use("en-US", enUS);
} else if (localStorage.lange == "jp") {
  Locale.use("ja-JP", jaJP);
} else {
  Locale.add("zh-CN");
}

Vue.filter("mapTitle", function(code: number) {
  return categoryMap[code].CategoryName;
});

Vue.prototype.getImgs = function(path: string, type: string) {
  let reg = /^app./g;
  let hostname = window.location.hostname;
  if (!reg.test(hostname) || hostname == "app.ecs.net") {
    hostname = "app.lchtrip.com";
  }
  if (!type || type == "img") {
    return `/static/${hostname.replace(/\./g, "")}/imgs/${path}`;
  } else {
    return `url(/static/${hostname.replace(/\./g, "")}/imgs/${path})`;
  }
};

Vue.prototype.$moment = moment;
const weekArr: any = {
  cn: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  jp: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};
moment.locale("zh-cn", { weekdaysShort: weekArr[localStorage.lange] || weekArr.cn });

Vue.component("page-frame", pageFrame);
Vue.component("botton-bar", bottonBar);
Vue.component("header-bar", headerBar);
Vue.component("loading-frame", loadingFrame);
Vue.component("amap", amap);

//vant ui
Vue.use(Icon)
  .use(Button)
  .use(Col)
  .use(Toast)
  .use(Row)
  .use(Dialog)
  .use(Notify);

Vue.config.productionTip = false;

if (process.env.NODE_ENV == "development") {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}
if (isOfw()) {
  document.title = "老友荟";
} else {
  document.title = "力程商旅";
}

let instance = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  watch: {
    "$i18n.locale"(newVal) {
      if (newVal) {
        document.cookie = `lang=${newVal};path=/;`;
      }
    },
  },
});
instance.$mount("#app");
// store.dispatch("reload").then(() => {
//   instance.$mount("#app");
// });
